export const environment = {
  production: true,
  appVersion: 'v1',
  USERDATA_KEY: 'sfa_dev',
  isMockEnabled: false,
  mapsAPIKey: 'AIzaSyA0Zjmz6tNuUOEbLTqP83Tk8K0fh1DswEk',
  apiUrl: 'https://api.sarfix.apptechasia.app/api/'
};
